export default __webpack_public_path__ + "static/media/p51.3f0d2d4d.jpg";